import { render, staticRenderFns } from "./HeroPage.vue?vue&type=template&id=5d6fc253"
import script from "./HeroPage.vue?vue&type=script&lang=js"
export * from "./HeroPage.vue?vue&type=script&lang=js"
import style0 from "./HeroPage.vue?vue&type=style&index=0&id=5d6fc253&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports